export default __webpack_public_path__ + "static/media/textWaterMarks.84594c12.svg";